"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _uuid = require("uuid");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconChevron = function IconChevron(_ref) {
  var className = _ref.className;
  var labelId = (0, _uuid.v4)();
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: className,
    viewBox: "0 0 50 50",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": labelId
  }, /*#__PURE__*/_react["default"].createElement("title", {
    id: labelId
  }, "Chevron"), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("polygon", {
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "30.2128906 25 9.31604249 4.05995176 15.0515759 0 40 25 15.0515759 50 9.31604249 45.9400482"
  })));
};

var _default = IconChevron;
exports["default"] = _default;